<template>
  <div ref="inputWrap" class="input-wrap" :class="[status, disabledcolor, border, boxshadow, size]">
    <slot name="beforecontents"></slot>
    <input
      ref="inputbox"
      class="input-wrap-item input-box"
      :class="[ftcolor, ftweight]"
      :placeholder="placeholder"
      :type="inputtype"
      :value="value"
      :readonly="disabled"
      autocomplete="off"
      aria-autocomplete="none"
      @focus="focusEvent"
      @blur="blurEvent"
      @click="clickEvent"
      @input="inputEvent"
      @keydown.enter="handlerEnter"
      @keyup.down="keyDown"
      @keypress="keyPress"
      @keydown.tab="keyDownTab"
      @compositionstart="isComposing = true"
      @compositionend="handleCompositionEnd"
    />
    <slot name="aftercontents"></slot>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'lg',
      required: false
    },
    inputtype: {
      type: String,
      default: 'text',
      required: false
    },
    border: {
      type: String,
      default: 'border-radius-8', // border-radius-8 , border-radius-50
      required: false
    },
    boxshadow: {
      type: String,
      default: '', //
      required: false
    },
    placeholder: {
      type: String,
      default: null,
      required: false
    },
    status: {
      type: String,
      default: 'no', // active , error, disabled
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    disabledcolor: {
      type: String,
      default: 'disabledwhite', // disabled, disabledwhite
      required: false
    },
    value: {
      type: String,
      default: null,
      required: false
    },
    ftcolor: {
      type: String,
      default: '', // ftblack600
      required: false
    },
    ftweight: {
      type: String,
      default: '', // fw500 , fw600
      required: false
    },
    maxlength: {
      type: Number,
      default: 9999,
      required: false
    }
  },
  emits: [
    'change-input',
    'click-event',
    'enter-event',
    'focus-event',
    'blur-event',
    'keydown-event',
    'keydowntab-event',
    'keypress-event'
  ],
  data() {
    return {
      isComposing: false
    };
  },
  methods: {
    keyDown() {
      this.$emit('keydown-event');
    },
    keyPress() {
      this.$emit('keypress-event');
    },
    keyDownTab() {
      this.$emit('keydowntab-event');
    },
    focusEvent(e) {
      e.preventDefault();

      if (this.status === 'no') {
        this.$refs.inputWrap.classList.add('focused');
      }
      this.$emit('focus-event');
    },
    blurEvent(e) {
      e.preventDefault();

      if (this.status === 'no') {
        this.$refs.inputWrap.classList.remove('focused');
      }
      this.$emit('blur-event');
    },
    textSlice(len = 10) {
      if (this.$refs.inputbox) {
        this.$refs.inputbox.value = this.$refs.inputbox.value.slice(0, len);
      }
    },
    clickEvent(e) {
      e.preventDefault();
      this.$emit('click-event');
    },
    inputEvent(e) {
      if (e.target) {
        e.target.value = e.target.value.slice(0, this.maxlength);
        this.$emit('change-input', e.target.value);
      }
    },
    handlerEnter(e) {
      e.preventDefault();
      if (!this.isComposing) {
        this.$emit('enter-event');
      }
    },
    handleCompositionEnd() {
      this.isComposing = false;
    },
    inputFocus() {
      this.$refs.inputbox.focus();
    }
  }
};
</script>
<style scoped src="@/assets/css/inputbox/inpubox.css"></style>
